import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full h-full absolute" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("line", {
  x2: "100%",
  y1: "100%",
  class: "stroke-1 stroke-gray-5"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("line", {
  x2: "100%",
  y2: "100%",
  class: "stroke-1 stroke-gray-5"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }